/**
 * Modales Globales Reutilizables de AviFácil
 * Exporta todos los modales transversales del sistema para fácil importación.
 */

// Modales Individuales de Redes Sociales y WhatsApp (Diseño individual por canal)
export {
  SocialIndividualModal,
  InstagramModal,
  FacebookModal,
  YouTubeModal,
  TikTokModal,
  GoogleModal,
  WhatsAppModal,
  type RedSocialId,
  type SocialIndividualModalProps,
  type SocialConfig,
  CANALES_CONFIG,
} from './SocialIndividualModal';

// Modales Especiales de Selección de Onboarding y Sistema
export {
  PrefijoWhatsappModalSelector,
  type PrefijoWhatsappModalSelectorProps,
  type PrefijoWhatsappItem,
} from './PrefijoWhatsappModalSelector';

export {
  IdiomaModalSelector,
  type IdiomaModalSelectorProps,
  type IdiomaItem,
} from '@/modulos/onboarding_clientes/components/IdiomaModalSelector';

// Modales Adicionales Reutilizables
export {
  RedesSocialesModal,
  type RedesSocialesModalProps,
} from './RedesSocialesModal';

export {
  WhatsAppSoporteModal,
  type WhatsAppSoporteModalProps,
} from './WhatsAppSoporteModal';
